import { useSettingsStore } from '../../stores';
import { type GetMenus } from '../../stores/modules/settings/types';

/**
 * 根据角色查询用户功能菜单权限
 * @param roleId 角色id
 */
export const getMenus: GetMenus = async (baseOn, routers, roleId) => {
  const { settings } = useSettingsStore();
  return settings.menu.getMenus?.(baseOn, routers, roleId) || { success: true, obj: [] };
};
